import { forwardRef } from 'react';

import { TextField } from '@/ui/TextField/base';
import { TextAreaProps } from './types';

/** Fix for ref warning for React Datepicker case @link https://github.com/Hacker0x01/react-datepicker/issues/2165#issuecomment-711032947 */
export const TextArea = forwardRef<HTMLInputElement, TextAreaProps>((props, ref) => <TextField {...props} multiline ref={ref} />);

TextArea.displayName = 'TextArea';
